import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { useGetCollectionYardVisitEventsQuery } from "../../api/citizenApi";
import { ContentLoader } from "../../components/ContentLoader";
import { GeneralTitle } from "../../components/GeneralTitle";
import { Layout } from "../../components/Layout/Layout";
import { Navbar } from "../../components/Navbar";
import { NavigateBackWithContent } from "../../components/NavigateBackWithContent";
import { RECYCLING_PATH } from "../../constants";
import { formattedDateTime } from "../../utils/date";
import { CollectionYardVisitEvents } from "../../components/PagesContent/CollectionYardVisitEvents";
import DownloadVisitReceipt from "../../components/PagesContent/DownloadVisitReceipt/DownloadVisitReceipt";
import styles from "./CollectionYardVisitEventsPage.module.scss";

export const CollectionYardVisitEventsPage = () => {
  const { t } = useTranslation();

  const { collectionYardVisitId } = useParams();
  const { data, isFetching, error } = useGetCollectionYardVisitEventsQuery({
    id: collectionYardVisitId!,
  });

  if (error) {
    return <Navigate to={RECYCLING_PATH} />;
  }

  if (isFetching || data === undefined) return <ContentLoader />;

  const topBar = (
    <div className={styles.container}>
      <NavigateBackWithContent
        rightComponent={
          <div className={styles.itemTitle}>
            <GeneralTitle
              mainText={t("visitOnDate", {
                date: formattedDateTime(new Date(data.created)),
              })}
              secondaryText={""}
            />
          </div>
        }
      />
    </div>
  );
  const navBar = <Navbar />;

  return (
    <Layout topBar={topBar} navBar={navBar}>
      <div className={styles.eventsContainer}>
        <CollectionYardVisitEvents events={data.events} />
      </div>
      <DownloadVisitReceipt
        visitId={data.visitId}
        created={data.created}
        priceSum={data.priceSum}
      />
    </Layout>
  );
};
